import localSave from '@utils/local-save'

export const state = {
    volume: localSave.get('volume') !== null ? localSave.get('volume') : 25,
    currentOnDemandQualityKey: localSave.get('currentOnDemandQualityKey') || 'low',
}

export const getters = {}

export const mutations = {
    SET_SETTINGS(state, { volume, currentOnDemandQualityKey }) {
        if (volume !== undefined) {
            state.volume = volume
            localSave.save('volume', state.volume)
        }

        if (currentOnDemandQualityKey !== undefined) {
            state.currentOnDemandQualityKey = currentOnDemandQualityKey
        }
    },
}

export const actions = {}
